import { render, staticRenderFns } from "./QuestionResolve.vue?vue&type=template&id=120503b6&scoped=true"
import script from "./QuestionResolve.vue?vue&type=script&lang=js"
export * from "./QuestionResolve.vue?vue&type=script&lang=js"
import style0 from "./QuestionResolve.vue?vue&type=style&index=0&id=120503b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120503b6",
  null
  
)

export default component.exports